// extracted by mini-css-extract-plugin
export default {"tableActionsTitle":"app-core-components-datatables-components-ActionsMenuTitle-module__table-actions-title"};